<template>
  <v-dialog v-model="dialog" :width="dialogWidth" :persistent="false" transition="fade-transition">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        <p v-if="name">{{name}}</p>
        <p>{{description}}</p>
        <p>{{$t('common.price')}}: {{price}}<v-icon small right>mdi-circle-multiple-outline</v-icon></p>
        <info-block class="pb-3" v-if="!available">Dieser Artikel ist derzeit nicht verfügbar</info-block>
        <v-checkbox
            v-model="withdrawal"
            :label="$t('common.abandon-withdrawal-rights')"
            required
            :rules="validationRules.required"
        ></v-checkbox>
        <v-btn @click="purchase" :disabled="!withdrawal" class="primary" :loading="loading">
          <v-icon left>mdi-circle-multiple-outline</v-icon>{{$tenant.tenant === 'bfv' ? $t('common.redeem-now') : $t('common.buy-now')}}
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" class="error" text @click="close()">
          <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InfoBlock from "@/widgets/InfoBlock";

export default {
  name: "PurchaseDialog",
  mixins: [],
  components: {InfoBlock},
  props: {
    title: {
      type: String,
      default: 'Checkout'
    },
    name: {
      type: String,
      required: false
    },
    visible: {
      type: Boolean,
      required: true
    },
    price: { // price in coins
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false
    },
    available: {
      type: Boolean,
      default: false
    },
    sku: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    confirmAction: {
      type: Function,
      required: false
    },
    closeAction: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false,
      withdrawal: false,
      validationRules: {
        required: [v => !!v || this.$t('common.mandatory-field')]
      },
    };
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    }
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "450";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    purchase() {
      if(this.withdrawal){
        this.confirmAction && this.confirmAction(this.sku);
      }
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
</style>
